<template>
  <card-collapsable
    :headerClass="headerClass"
    dialogClass="selvaggia"
    :dialogProp="dialog"
  >
    <!-- :collapsed="collapsed" -->
    <!-- always visible -->
    <template #visible>
      <progress-countdown
        v-show="asta_settings.timeout_s && calciatoreInAsta"
        ref="timer_selvaggia"
        :time="asta_settings.timeout_s"
        @timeover="timeoverSelvaggia"
        name="selvaggia"
      ></progress-countdown>
    </template>

    <!-- card-title -->
    <template #title>
      {{
        ruoloCalciatoreInAstaCompletato
          ? "Ruolo completato"
          : creditiInsufficienti && !sonoVincitore
          ? "Crediti insufficienti"
          : hoPassato
          ? "Hai passato"
          : sonoVincitore
          ? "Migliore offerta"
          : "Fai offerta"
      }}
    </template>

    <!-- card-body -->
    <template #body>
      <calciatore-battuto
        :id="calciatoreInAsta"
        v-if="calciatoreInAsta"
        xLarge
      ></calciatore-battuto>

      <div class="text-center">
        <!-- Questo flex serve affinchè l'animazione sonoVincitore nn provochi scroll -->
        <div class="d-flex justify-center">
          <!-- migliore offerta corrente-->
          <squadra-offerta
            :offerta="migliore_offerta.offerta"
            :uid="migliore_offerta.vincitore"
            :ifNoOfferta="'Nessuna offerta'"
            :class="{ sonoVincitore }"
          ></squadra-offerta>
        </div>
        <!-- Non puoi alzare ulteriormente l'offerta -->
        <div
          v-if="
            !timeover &&
            running &&
            calciatoreInAsta !== null &&
            sonoVincitore &&
            creditiInsufficienti
          "
          class="pa-2"
        >
          <v-chip class="white primary--text"
            >Non puoi alzare ulteriormente l'offerta</v-chip
          >
        </div>
        <!-- pulsanti -->
        <div
          class="pa-4"
          v-else-if="
            !timeover && running && calciatoreInAsta !== null && !hoPassato
          "
        >
          <!-- +1 -->
          <div v-if="migliore_offerta.offerta" class="d-flex justify-center">
            <v-btn
              v-if="!offertaToConfirm"
              rounded
              color="primary"
              class="ma-1"
              @click="offertaToConfirm = migliore_offerta.offerta + 1"
              >+1</v-btn
            >
            <div
              v-else-if="offertaToConfirm"
              class="d-flex flex-column align-center"
            >
              <div
                v-if="offertaInsufficiente"
                class="d-flex align-center error--text"
              >
                <v-icon small left class="error--text">error</v-icon>
                Offerta ora insufficiente. Vuoi offrire
                {{ offertaToConfirm }} ?
              </div>
              <v-btn
                rounded
                color="primary"
                class="ma-1"
                @click="confirmOfferta"
                >Confermo
                <span class="ml-2 crediti">{{ offertaToConfirm }}</span>
              </v-btn>
            </div>
          </div>
          <div class="d-flex justify-center">
            <!-- offerta -->
            <v-btn
              class="ma-1"
              color="primary"
              id="numpad-btn"
              rounded
              depressed
              @click="showNumpad"
            >
              Offerta
            </v-btn>
            <!-- passo -->
            <v-btn
              color="primary"
              class="ma-1"
              outlined
              rounded
              @click="setPasso(true)"
              :disabled="vincitore === user_uid"
            >
              Passo
            </v-btn>
          </div>
        </div>
        <div v-else class="pa-2">
          <v-chip class="orange white--text"
            >In attesa degli altri partecipanti...</v-chip
          >
        </div>
      </div>
    </template>

    <!-- footer -->
    <template #actions>
      <div v-if="my_squadra" class="pa-4">
        <squadra-info-panel :id_squadra="user_uid"></squadra-info-panel>
      </div>
      <div v-if="my_squadra" class="px-4 pb-4">
        <v-list
          :class="{ 'nice-scroll': !is_mobile }"
          class="recycle-scroller navy darken-1 pb-2 rounded"
        >
          <div class="text-center py-2 ">Pianificazione</div>
          <asta-consiglio></asta-consiglio>
          <asta-slot
            v-for="(slotData, slot, i) in myPlan[ruolo_abc]"
            :key="ruolo_abc + '_' + slot"
            :ruolo_abc="ruolo_abc"
            :iSlot="slot"
            :i="i"
          ></asta-slot>
        </v-list>
      </div>
    </template>
  </card-collapsable>
</template>

<script>
import db from "../../js/db";
import Vuex from "vuex";
import Constants from "../../js/constants";
import mixins from "../../js/mixins";

import toast from "../../js/toast";
import ProgressCountdown from "../common/ProgressCountdown";
import SquadraInfoPanel from "../common/SquadraInfoPanel";
import CalciatoreBattuto from "../common/CalciatoreBattuto";
import CardCollapsable from "../common/CardCollapsable";
import SquadraOfferta from "../common/SquadraOfferta";
import AstaSlot from "../AstaSlot";
import AstaConsiglio from "../AstaConsiglio";

import * as Helpers from "../../js/helpers";

export default {
  name: "asta-selvaggia",
  mixins: [mixins, toast],
  components: {
    ProgressCountdown,
    SquadraInfoPanel,
    CalciatoreBattuto,
    CardCollapsable,
    SquadraOfferta,
    AstaSlot,
    AstaConsiglio
  },
  data() {
    return {
      vincitorePrev: null,
      resetT: false,
      timeover: true,
      processing: false,
      offertaToConfirm: false,
      offertaInsufficiente: false,
    };
  },
  mounted() {
    console.log("--> AstaSelvaggia ready.");
    db.on("numpadSubmitted", this.setOffertaCustom);
    db.on("offerte", this.forzaPassoIfNoCrediti);
    db.on("status", this.handleTimer);
  },
  destroyed() {
    console.log("<-- AstaSelvaggia destroyed.");
    db.off("numpadSubmitted", this.setOffertaCustom);
    db.off("offerte", this.forzaPassoIfNoCrediti);
    db.off("status", this.handleTimer);
  },
  methods: {
    dismiss() {
      this.hideNumpad();
    },
    showNumpad() {
      db.emit("numpad", true);
    },
    hideNumpad() {
      db.emit("numpad", false);
    },
    async timeoverSelvaggia() {
      this.timeover = true;
      this.vincitorePrev = this.vincitore;
      await this.wait(2000);
      if (
        this.vincitore == this.vincitorePrev &&
        this.vincitore !== this.user_uid &&
        this.vincitorePrev !== this.user_uid &&
        this.running &&
        this.squadra(this.user_uid).active
      ) {
        this.setPasso();
      }
    },
    setPasso(confirm = false) {
      // passo solo se non sono il vincitore (il check serve per evitare di sovrascrivere offerta al timeout)
      if (confirm) {
        Swal.fire({
          title: "Vuoi passare?",
          text: "Non potrai annullare l'operazione",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Si",
          cancelButtonText: "No",
        }).then((result) => {
          if (result.isConfirmed == true) {
            db.setOfferta(Constants.OFFERTA.PASSO, false, true);
          }
        });
      } else {
        db.setOfferta(Constants.OFFERTA.PASSO, false, true);
        Swal.close();
      }
    },
    setOffertaCustom(val) {
      this.dismiss();
      this.setOfferta(val);
    },
    // checkOfferta(offerta) {
    //   // if (offerta > this.maxOfferta || offerta < this.minOfferta) {
    //   //   this.error = true;
    //   //   this.processing = false;
    //   //   this.errorValue = this.value;
    //   //   this.clear();
    //   //   return;
    //   // }
    //   return false;
    // },
    confirmOfferta() {
      if (this.offertaToConfirm) {
        // se è + alta di quella corrente, impostala
        if (this.offertaToConfirm > this.migliore_offerta.offerta) {
          this.setOfferta(this.offertaToConfirm);
          this.offertaToConfirm = false;
          this.offertaInsufficiente = false;
        } else {
          // altrimenti chiedi direttamente se vuole offrire di più
          this.offertaToConfirm = this.migliore_offerta.offerta + 1;
          this.offertaInsufficiente = true;
        }
      }
    },
    async setOfferta(val) {
      try {
        if (this.processing) return;
        this.processing = true;
        // this.action = true;
        await db.setOfferta(val, false, true);
        this.processing = false;
      } catch (error) {
        this.processing = false;
        throw new Error(error);
      }
    },
    startTimer() {
      this.timeover = false;
      if (this.$refs["timer_selvaggia"] === null) {
        console.log('$refs["timer_selvaggia"] è null');
      } else {
        this.$refs["timer_selvaggia"].start();
      }

      // NECESSARIO PER RITARDARE L'ASSEGNAZIONE DI resetT
      setTimeout(() => {
        this.resetT = true;
      }, 0);
    },
    stopTimer() {
      if (this.$refs["timer_selvaggia"] === null) {
        console.log('$refs["timer_selvaggia"] è null');
      } else {
        this.$refs["timer_selvaggia"].stop();
      }
    },
    resetTimer() {
      if (this.$refs["timer_selvaggia"] === null) {
        console.log('$refs["timer_selvaggia"] è null');
      } else {
        this.$refs["timer_selvaggia"].updateTimer(this.asta_settings.timeout_s);
      }
    },
    handleTimer(status) {
      if (this.calciatoreInAsta !== null) {
        switch (status) {
          case Constants.ASTA_STATUS.NOT_RUNNING:
            this.stopTimer();
            break;
          case Constants.ASTA_STATUS.RUNNING:
            this.startTimer();
            break;
        }
      }
    },
    forzaPassoIfNoCrediti() {
      // in AstaSelvaggia l'eventuale passo lo decide ogni squadra per se al momento
      if (
        this.calciatoreInAsta !== null &&
        !this.sonoVincitore &&
        this.squadra(this.user_uid).active
      ) {
        if (!this.hoPassato && this.creditiInsufficienti) {
          this.setPasso();
        }
        // let offerta = Helpers.calcoloOfferta(
        //   this.asta_info,
        //   this.squadra(this.user_uid),
        //   this.calciatore(this.calciatoreInAsta),
        //   this.migliore_offerta.offerta + 1
        // );
        // if (offerta === Constants.OFFERTA.PASSO && !this.hoPassato) {
        //   this.setPasso();
        // }
      }
    },
  },
  watch: {
    calciatoreInAsta(val, oldVal) {
      if (this.running) {
        if (val === null) {
          if (oldVal !== undefined) {
            this.stopTimer();
          }
        } else {
          this.startTimer();
        }
      }
    },
    /*vincitore: function (val, oldVal) {
        // aggiorno timer se cambia vincitore nel round
        if (oldVal != null || this.resetT) {
          this.timeover = false;
          this.resetTimer();
        }
      },*/
    offerta(val, oldVal) {
      // aggiorno timer se cambia offerta nel round
      if (oldVal != null || this.resetT) {
        this.timeover = false;
        this.resetTimer();
      }
    },
    timeover(val) {
      if (val) {
        this.hideNumpad();
      }
    },
    dialog(val) {
      if (!val) {
        this.hideNumpad();
        this.offertaToConfirm = false;
        this.offertaInsufficiente = false;
      }
    },
  },
  computed: {
    headerClass() {
      return {
        text: !this.hoPassato && !this.sonoVincitore,
        red: this.hoPassato,
        accent: this.sonoVincitore,
        "white--text": true,
      };
    },
    // collapsed() {
    //   return false;
    // },
    // calciatoreInAsta() {
    //   return this.asta_round.calciatoreInAsta;
    // },
    ruolo_abc() {
      if (this.calciatoreInAsta != null) {
        return Constants.RUOLI_NEW[
          this.calciatori[this.calciatoreInAsta].ID_Ruolo
        ].abc;
      }
      return null;
    },
    vincitore() {
      return this.migliore_offerta.vincitore;
    },
    offerta() {
      return this.migliore_offerta.offerta;
    },
    sonoVincitore() {
      return this.migliore_offerta.vincitore == this.user_uid;
    },
    hoPassato() {
      return (
        this.asta_round.offerte &&
        this.asta_round.offerte[this.user_uid] == Constants.OFFERTA.PASSO
      );
    },
    minOfferta() {
      return this.migliore_offerta.vincitore != null
        ? this.migliore_offerta.offerta + Constants.RILANCIO_MIN
        : Helpers.minOfferta(
            this.asta_settings.base_asta,
            this.calciatore(this.asta_round.calciatoreInAsta)
          );
    },

    creditiInsufficienti() {
      // se non ho crediti sufficienti a superare l'offerta vincente
      if (this.squadra(this.user_uid)) {
        return !Helpers.canOffrire(
          this.squadra(this.user_uid),
          this.minOfferta
        );
      }

      // return (
      //   Helpers.calcoloOfferta(
      //     this.asta_info,
      //     this.squadra(this.user_uid),
      //     this.calciatore(this.calciatoreInAsta),
      //     this.migliore_offerta.offerta
      //   ) === Constants.OFFERTA.PASSO
      // );
    },
    dialog() {
      return Boolean(
        this.squadra(this.user_uid) &&
          this.squadra(this.user_uid).active &&
          this.calciatoreInAsta !== null &&
          this.calciatoreInAsta !== undefined &&
          this.running
        // && !this.creditiInsufficienti // nn voglio che si chiuda in questo caso
      );
    },
    ...Vuex.mapGetters([
      "migliore_offerta",
      "myPlan",
    ]),
  },
};
</script>
<style lang="scss" scoped>
.crediti {
  width: 25px;
  height: 25px;
  font-size: 11px;
}
.sonoVincitore {
  animation: vanishIn 0.5s;
}
</style>
